import { render } from "./DetalhesNotasFiscais.vue?vue&type=template&id=05c1fbd8&scoped=true"
import script from "./DetalhesNotasFiscais.vue?vue&type=script&lang=js"
export * from "./DetalhesNotasFiscais.vue?vue&type=script&lang=js"

import "./DetalhesNotasFiscais.vue?vue&type=style&index=0&id=05c1fbd8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c1fbd8"]])

export default __exports__